export default {
  path: '/logs',
  component: () => import(
    /* webpackChunkName: "log" */
    /* webpackPrefetch: true */
    './List'
  ),
  children: [
    {
      path: 'export',
      component: () => import(
        /* webpackChunkName: "log-export" */
        /* webpackPrefetch: true */
        './Export'
      ),
    },
    {
      path: 'create',
      component: () => import(
        /* webpackChunkName: "log-create" */
        /* webpackPrefetch: true */
        './Create'
      ),
    },
    {
      path: ':id',
      component: () => import(
        /* webpackChunkName: "log-detail" */
        /* webpackPrefetch: true */
        './Detail'
      ),
    },
  ],
};
